import { render, staticRenderFns } from "./PopoutMenu.vue?vue&type=template&id=52c5ff86&scoped=true&"
import script from "./PopoutMenu.vue?vue&type=script&lang=js&"
export * from "./PopoutMenu.vue?vue&type=script&lang=js&"
import style0 from "./PopoutMenu.vue?vue&type=style&index=0&id=52c5ff86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c5ff86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52c5ff86')) {
      api.createRecord('52c5ff86', component.options)
    } else {
      api.reload('52c5ff86', component.options)
    }
    module.hot.accept("./PopoutMenu.vue?vue&type=template&id=52c5ff86&scoped=true&", function () {
      api.rerender('52c5ff86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/PopoutMenu.vue"
export default component.exports